import request from '@/utils/request'

//客户下单接口
export const clientPlaceAnOrder = (data) => {
    return request({
        url: '/hqprotal/orderManage/clientPlaceAnOrder',
        method: 'post',
        data
    })
}


//获取生产商订单管理详细信息
export const plantOrderData = () => {
    return request({
        url: '/hqprotal/orderManage/selectOrderInformation',
        method: 'get',
    })
}

//接单
export const factoryAcceptOrder = (id) => {
    return request({
        url: `/hqprotal/orderManage/factoryAcceptOrder/${id}`,
        method: 'post',
    })
}

//商品品类接口
export const getDicts = (dictType) => {
    return request({
      url: '/system/dict/data/type/' + dictType,
      method: 'get'
    })
  }

  //订单详情接口
  export const clientProductExhibition =(params) => {
    return request({
        url: `/hqprotal/orderManage/clientProductExhibition/`,
        method: 'get',
        params
      })
  }

  //确认收货接口
  export const clintHarvest =(id) => {
    return request({
        url: `/hqprotal/orderManage/clintHarvest?orderId=${id}`,
        method: 'get',
      })
  }

  //待评价接口
  export const orderEvaluation =(data) => {
    return request({
        url: `/hqprotal/orderManage/orderEvaluation`,
        method: 'post',
        data
      })
  }

  //查询用户信息是否完善
  export const selectIsInfo = () => {
    return request({
        url: `/hqprotal/information/selectIsInfo`,
        method: 'get',
      })
  }

  //查询生产商信息是否完善
  export const mangeInfo = () => {
    return request({
        url: `/hqprotal/manage/selectIsInfo`,
        method: 'get',
      })
  }

  //查询订单完成数量根据日期查询
export const selectOrderAccomplishByOrderId = (data) => {
  return request({
      url: `/hqprotal/accomplish/selectOrderAccomplishByOrderId`,
      method: 'post',
      data
  })
}

//查询工厂详情
export const plantProductExhibition = (id) => {
  return request({
      url: `/hqprotal/orderManage/plantProductExhibition?orderId=${id}`,
      method: 'get',
  })
}